import React from "react"
import { blogSlug } from "components/Blog/utils/Blog.utils"
import type { BlogV2TagParsed } from "types/blog-v2-types"
import { ChevronDown } from "components/SVG"

import { Toggleable } from "packages/ui-shared/components/Toggleable/Toggleable"

import {
  container,
  containerMargin,
  triggerContainer,
  itemsContainer,
  itemContainer,
} from "./MobileBlogNav.css"

type Props = {
  navItems: BlogV2TagParsed[]
  currentPage: string
  blogPage?: boolean
  test?: boolean
  locale: "en-GB" | "en-US"
}

export const MobileBlogNav: React.FC<Props> = ({
  navItems,
  currentPage,
  locale,
  blogPage = false,
  test = false,
}) => {
  const latest = {
    title: "Latest",
    slug: blogSlug,
  }
  const itemsToPost = [latest, ...navItems]

  const blogSlugLocale = locale === "en-US" ? `/us${blogSlug}` : blogSlug

  const containerClass = blogPage
    ? `${container} ${containerMargin}`
    : container
  return (
    <div className={containerClass}>
      <Toggleable
        triggerItem={
          <div className={triggerContainer}>
            <span>Categories</span>
            <ChevronDown />
          </div>
        }
        contentItem={
          <div className={itemsContainer}>
            {itemsToPost.map((navItem) => {
              const { title, slug } = navItem
              return (
                <div className={itemContainer} key={slug}>
                  <a
                    title={title}
                    href={
                      title === "Latest"
                        ? blogSlugLocale
                        : `${blogSlugLocale}/tag/${slug}`
                    }
                    className={slug === currentPage ? "active" : ""}
                  >
                    {title}
                  </a>
                </div>
              )
            })}
          </div>
        }
        defaultValue={test ? "item-1" : undefined}
      />
    </div>
  )
}
